import { Stack, Typography, useMediaQuery, useTheme } from "@mui/material"
import CustomDialog from "components/CustomDialog"
import SelectInput from "components/files/SelectInput"
import { useBizTypeTranslation } from "hooks/useBizTypeTranslation"
import useDataManager from "hooks/useDataManager"
import { useEffect } from "react"
import { useForm } from "react-hook-form"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { setChangeBizLoading } from "store/sysSlice"
import { setSelectedPlugin } from "store/userSettingsSlice"

const ChangeBiz = ({ data, setData }) => {
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const theme = useTheme()
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const { selectBiz } = useDataManager()
    const { bt } = useBizTypeTranslation();
    const biz = useSelector((state) => state?.biz?.data);
    const { reset, handleSubmit, control, watch, formState: { errors } } = useForm();

    useEffect(() => {
        if (data?.list?.length > 0)
            reset({ biz: data?.list[0]?.id })
    }, [data]);

    const onSubmit = (values) => {
        dispatch(setChangeBizLoading(true));
        setTimeout(() => {
            dispatch(setSelectedPlugin(data?.pluginSysName));
            selectBiz(values?.biz)
            onClose()
        }, 100);
    }

    const onClose = () => {
        setData({ open: false, list: [], pluginSysName: null })
    }

    return (
        <CustomDialog
            title="MOVE_TO_BIZ"
            open={data.open}
            contentPadding={3}
            onClose={onClose}
            actionBtn={{ title: "CONTINUE", onClick: () => handleSubmit(onSubmit)() }}
            closeBtn='CANCEL'
        >
            <form onSubmit={handleSubmit(onSubmit)}>
                <Stack alignItems="center" spacing={3}>
                    <Stack alignItems="center">
                        <Typography textAlign="center" variant={isMobile ? "h6" : "h5"}>
                            {biz?.name}
                        </Typography>
                        <Typography color="error.text" textAlign="center" variant={isMobile ? "body1" : "h6"}>
                            {`${bt("BIZ_NOT_INCLUDE_PLUGIN")}`}
                        </Typography>
                    </Stack>


                    <SelectInput
                        width={250}
                        control={control}
                        errors={errors}
                        name="biz"
                        title={bt("SELECT_BIZ_TO_MOVE")}
                        required
                        options={data?.list?.map(biz => {
                            return { name: biz?.name, id: biz?.id }
                        })}
                    />
                </Stack>
            </form>

        </CustomDialog >
    )
}
export default ChangeBiz